import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  Typography,
} from "@mui/material";
import { sendPublicStkPush } from "../../redux/actions/checkoutActions";
import { resetPublicStkPushState } from "../../redux/slices/checkout";

const PublicStkPushModal = ({
  open,
  onClose,
  token,
  balanceDue,
  defaultPhone,
  onSuccess,
}) => {
  const dispatch = useDispatch();

  const { loadingPublicStkPush, publicStkPushSuccess } = useSelector(
    (state) => state.checkout,
  );

  const [phone, setPhone] = useState(defaultPhone || "");

  useEffect(() => {
    if (defaultPhone) {
      setPhone(defaultPhone);
    }
  }, [defaultPhone]);

  useEffect(() => {
    if (publicStkPushSuccess) {
      dispatch(resetPublicStkPushState());
      if (onSuccess) {
        onSuccess();
      }
      onClose();
    }
  }, [publicStkPushSuccess, dispatch, onClose, onSuccess]);

  const handleSubmit = () => {
    if (!phone || !token) return;

    dispatch(sendPublicStkPush({ token, phoneNumber: phone }));
  };

  return (
    <Dialog
      open={open}
      onClose={loadingPublicStkPush ? undefined : onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>Pay via M-Pesa</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" mb={3} mt={1}>
          Enter your M-Pesa number. You will receive a prompt on your phone to
          enter your PIN and complete the payment.
        </Typography>
        <Stack spacing={2}>
          <TextField
            label="M-Pesa Phone Number"
            fullWidth
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="e.g. 2547XXXXXXXX"
            disabled={loadingPublicStkPush}
            autoFocus
          />
          <TextField
            label="Amount Due"
            type="number"
            fullWidth
            value={balanceDue}
            disabled
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          color="inherit"
          disabled={loadingPublicStkPush}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="success"
          disabled={loadingPublicStkPush || !phone}
        >
          {loadingPublicStkPush ? "Sending Prompt..." : "Send Prompt"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PublicStkPushModal;
